export default class VodProviderService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('vodProviders', params)
	}
	getSimpleList(params) {
		return this.apiService.callGet('vodProviders/simple', params)
	}

	getListWithPackagesVisibility(params) {
		return this.apiService.callGet('vodProviders/listWithPackages', params)
	}


	getPackagesForService(params) {
		return this.apiService.callGet('vodProviders/packagesForService', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('vodProviders/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/VodProviderService.js